var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMistralAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_1871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1079 0H22.4863V5.62158H28.1079V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9187 0H25.2971V5.62158H30.9187V0Z",
    fill: "#F7D046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62158 0H0V5.62158H5.62158V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62158 5.62158H0V11.2432H5.62158V5.62158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62158 11.2432H0V16.8647H5.62158V11.2432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62158 16.8647H0V22.4863H5.62158V16.8647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62158 22.4863H0V28.1079H5.62158V22.4863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43237 0H2.81079V5.62158H8.43237V0Z",
    fill: "#F7D046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9187 5.62158H25.2971V11.2432H30.9187V5.62158Z",
    fill: "#F2A73B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43237 5.62158H2.81079V11.2432H8.43237V5.62158Z",
    fill: "#F2A73B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4863 5.62158H16.8647V11.2432H22.4863V5.62158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2971 5.62158H19.6755V11.2432H25.2971V5.62158Z",
    fill: "#F2A73B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.054 5.62158H8.43237V11.2432H14.054V5.62158Z",
    fill: "#F2A73B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6755 11.2432H14.054V16.8647H19.6755V11.2432Z",
    fill: "#EE792F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2971 11.2432H19.6755V16.8647H25.2971V11.2432Z",
    fill: "#EE792F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.054 11.2432H8.43237V16.8647H14.054V11.2432Z",
    fill: "#EE792F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8647 16.8647H11.2432V22.4863H16.8647V16.8647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6755 16.8647H14.054V22.4863H19.6755V16.8647Z",
    fill: "#EB5829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9187 11.2432H25.2971V16.8647H30.9187V11.2432Z",
    fill: "#EE792F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43237 11.2432H2.81079V16.8647H8.43237V11.2432Z",
    fill: "#EE792F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1079 16.8647H22.4863V22.4863H28.1079V16.8647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9187 16.8647H25.2971V22.4863H30.9187V16.8647Z",
    fill: "#EB5829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1079 22.4863H22.4863V28.1079H28.1079V22.4863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43237 16.8647H2.81079V22.4863H8.43237V16.8647Z",
    fill: "#EB5829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9187 22.4863H25.2971V28.1079H30.9187V22.4863Z",
    fill: "#EA3326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43237 22.4863H2.81079V28.1079H8.43237V22.4863Z",
    fill: "#EA3326"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9146,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistralAi);
export default __webpack_public_path__ + "static/media/MistralAI.ebb63bbd9df996eca4da8cfa0f186608.svg";
export { ForwardRef as ReactComponent };